export enum Countries {
  Belgium = 'Belgium',
  Canada = 'Canada',
  France = 'France',
  UnitedStates = 'United States',
  UnitedKingdom = 'United Kingdom',
}
